import React from 'react'
import { Route, Routes } from 'react-router'
import AdminLandingPage from '../app/landing/pages/AdminLandingPage'
import EmployeeDashboardPage from '../app/admin/erp/employee/pages/EmployeeDashboardPage'
import EmployeeDetailsPage from '../app/admin/erp/employee/pages/EmployeeDetailsPage'
import EmployeePrintIdCardPage from '../app/admin/erp/employee/pages/EmployeeIdPrintCardPage'
import ProjectDashboardPage from '../app/admin/erp/project/pages/ProjectDashboardPage'
import AttendanceDashboardPage from '../app/admin/erp/hrms/pages/AttendanceDashboardPage'
import LeaveRequestDashboardPage from '../app/admin/erp/hrms/pages/LeaveRequestDashboardPage'
import WorkReportDashboardPage from '../app/admin/erp/hrms/pages/WorkReportDashboardPage'
import HolidayListPage from '../app/admin/erp/hrms/pages/HolidayListPage'
import ProjectDetailsPage from '../app/admin/erp/project/pages/ProjectDetailsPage'
import ProjectTeamListPage from '../app/admin/erp/project/pages/ProjectTeamListPage'
import ProjectTeamDetailsPage from '../app/admin/erp/project/pages/ProjectTeamDetailsPage'
import TaskDashboardPage from '../app/admin/erp/tasks/pages/TaskDashboardPage'
import ProjectTaskListPage from '../app/admin/erp/project/pages/ProjectTaskListPage'
import FinanceRoutes from './FinanceRoutes'
import TaskArchivedPage from '../app/admin/erp/tasks/pages/TaskArchivedPage'
import FmsRoutes from './FmsRoutes'
import ProjectTargetListPage from '../app/admin/erp/project/pages/ProjectTargetListPage'
import HRMSComapnyDashboardPage from '../app/admin/erp/hrms/pages/HRMSComapnyDashboardPage'
import HRMSCompanyLocationListPage from '../app/admin/erp/hrms/pages/HRMSCompanyLocationListPage'
import CrmRoutes from './CrmRoutes'
import PortalListPage from '../app/portals/pages/PortalListPage'
import EmployeeAttendancePage from '../app/admin/erp/hrms/pages/EmployeeAttendancePage'





function ManagerRoutes() {
  return (
    <>
      <Routes>
        {/* Admin */}
        <Route path="/" element={ <AdminLandingPage /> }></Route>



        {/* ERP Pages */}

        <Route path="/project/dashboard" element={<ProjectDashboardPage /> }></Route>
        <Route path="/project/details/:id" element={<ProjectDetailsPage /> }></Route>
        <Route path="/project/team-list/:id" element={<ProjectTeamListPage /> }></Route>
        <Route path="/project/team-details/:id" element={<ProjectTeamDetailsPage /> }></Route>
        
        <Route path="/project/target-list/:id" element={<ProjectTargetListPage /> }></Route>

        

        <Route path="/task/dashboard" element={<TaskDashboardPage /> }></Route>
        <Route path="/task/archived" element={<TaskArchivedPage/> }></Route>

        
        <Route path="/hrms/company/dashboard" element={<HRMSComapnyDashboardPage /> }></Route>
        <Route path="/hrms/company/location" element={<HRMSCompanyLocationListPage /> }></Route>


                
        <Route path="/employee/dashboard" element={<EmployeeDashboardPage /> }></Route>
        <Route path="/employee/details/:id" element={<EmployeeDetailsPage /> }></Route>
        <Route path="/employee/print-id-card" element={<EmployeePrintIdCardPage /> }></Route>

        <Route path="/attendance/dashboard" element={<AttendanceDashboardPage /> }></Route>
        <Route path="/attendance/employee/:id" element={<EmployeeAttendancePage /> }></Route>
        <Route path="/leave-request/dashboard" element={<LeaveRequestDashboardPage /> }></Route>
        <Route path="/work-report/dashboard" element={<WorkReportDashboardPage /> }></Route>
        <Route path="/holiday-list/dashboard" element={<HolidayListPage /> }></Route>

        <Route path="/portal-list/dashboard" element={<PortalListPage /> }></Route>

        


      </Routes>
      <CrmRoutes/>
      <FmsRoutes/>
      <FinanceRoutes />
    </>
  )
}

export default ManagerRoutes